import { Card, Container, Row } from "reactstrap";
import { GLOBAL_CONSTANTS } from "../../utils/Constants";
import { useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useAuth } from "./AuthContext/AuthContext";
import { getPaymentMerchantInfo } from "../../service/api";
import { validateImageURL } from "../../utils/utils";
import { Dimmer, Loader } from "semantic-ui-react";

const Navbar = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [merchantLogoUrl, setMerchantLogoUrl] = useState();

  const isFirstRender = useRef(true);

  const { tenant, publicKey } = useParams();
  const { getAuthToken } = useAuth();

  const searchPaymentMerchantInfo = async () => {
    const accessToken = await getAuthToken();

    getPaymentMerchantInfo(accessToken, publicKey, tenant)
      .then(async (response) => {
        const isValidLogo = await validateImageURL(response.data.logoURL);
        if (isValidLogo) {
          setMerchantLogoUrl(response.data.logoURL);
        }
      })
      .catch((error) => {
        console.error("Error fetching payment merchant info:", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;

      if (publicKey && tenant) {
        searchPaymentMerchantInfo();
      } else {
        setIsLoading(false);
      }
    }
  }, []);

  return (
    <Container fluid>
      <Row className="justify-content-center">
        <Card body className="text-center">
          <div>
            {isLoading ? (
              <Dimmer active inverted>
                <Loader inverted />
              </Dimmer>
            ) : (
              <img
                class="logo centrada-horizontalmente"
                src={merchantLogoUrl ?? GLOBAL_CONSTANTS.MORE_UNITELLER_LOGO}
                alt="More Payment Evolution"
                style={{ maxWidth: "125px" }}
              />
            )}
          </div>
        </Card>
      </Row>
    </Container>
  );
};

export default Navbar;
